// @flow

import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { roomsFragment } from 'common/fragments/www'
import { parseRoomIdParam } from 'helpers/room'

const roomGQL = gql`
  query room(
    $id: Int,
    $uid: String,
  ) {
    room(id: $id, uid: $uid, rentType: DAY_TIME) {
      id
      uid
      neighborhoodRooms {
        ${roomsFragment}
      }
    }
  }
`

export default function(component: any) {
  return graphql(roomGQL, {
    options: props => ({
      variables: parseRoomIdParam(props.match.params.roomId),
    }),
    skip: ({ config }) => false, //config.SSR,
  })(component)
}



// WEBPACK FOOTER //
// ./src/containers/organisms/room/RoomCardSlider/NeighborhoodRooms/graphql.js